<nz-form-item>
  <nz-form-label [nzSpan]="6" nzFor="startNodeType">{{ showSearchType }} Type</nz-form-label>
  <nz-form-control [nzSpan]="18">
    <nz-select [(ngModel)]="labelSelect" (ngModelChange)="getProperties(labelSelect)">
      <nz-option nzLabel="All" nzValue="all"></nz-option>
      <nz-option *ngFor="let label of labels; let id = index;" [nzLabel]="label" [nzValue]="label">
      </nz-option>
    </nz-select>
  </nz-form-control>
</nz-form-item>

<form nz-form [formGroup]="startNodeForm">
  <div *ngFor='let control of listOfControl; let i = index;'>
    <nz-form-item>
      <nz-form-label [nzLg]="6" [nzXs]="6" [nzFor]="control.controlInstance + 'properties'">Property</nz-form-label>
      <nz-form-control [nzLg]="18" [nzXs]="18">
        <nz-select [(ngModel)]="control.attrName" [attr.id]="control.controlInstance + 'properties'"
          [(formControlName)]="control.controlInstance" >
          <nz-option *ngFor="let startOption of properties" [nzLabel]="startOption" [nzValue]="startOption">
          </nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzLg]="6" [nzXs]="6" [nzFor]="control.controlInstance + 'condition'">Condition</nz-form-label>
      <nz-form-control [nzLg]="18" [nzXs]="18">
        <nz-select [(ngModel)]="control.optNum" [attr.id]="control.controlInstance + 'condition'"
          [(formControlName)]="control.controlInstance" >
          <nz-option nzLabel="Equal To" nzValue="2" selected></nz-option>
          <nz-option nzLabel="Fuzzy" nzValue="5" selected></nz-option>
          <nz-option nzLabel="Unequal To" nzValue="4" selected></nz-option>
          <nz-option nzLabel="Greater Than" nzValue="greaterThan" selected></nz-option>
          <nz-option nzLabel="Greater Than or Equal To" nzValue="1" selected></nz-option>
          <nz-option nzLabel="Less Than" nzValue="lessThan" selected></nz-option>
          <nz-option nzLabel="Less Than or Equal To" nzValue="3" selected></nz-option>
          <nz-option nzLabel="Contains" nzValue="in" selected></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzLg]="6" [nzXs]="6" [nzFor]="control.controlInstance + 'value'">Value</nz-form-label>
      <nz-form-control [nzLg]="18" [nzXs]="18">
        <div nz-row>
          <div nz-col [nzLg]="12" [nzXs]="12">
            <input nz-input [(ngModel)]="control.reference" [attr.id]="control.controlInstance + 'value'"
              [(formControlName)]="control.controlInstance" />
          </div>
          <div nz-col [nzLg]="10" [nzXs]="10" [nzOffset]="2">
            <button nz-button nzDanger="true" nzType="dashed" class="delete-button" (click)="removeField(control, $event)">
              <i nz-icon nzType="minus-circle"></i>
              Delete
            </button>
          </div>
        </div>
      </nz-form-control>
    </nz-form-item>
    <nz-divider [nzDashed]="true"></nz-divider>
  </div>
</form>
<button *ngIf="labelSelect" nz-button nzType="dashed" class="add-button" (click)="addField($event)">
  <i nz-icon nzType="plus"></i>
  Add Filter Condition
</button>
